import { EndorsementRoutes, type EndorsementMode } from "@routing/paths";

export const STEP_ORDER: EndorsementRoutes[] = [
  EndorsementRoutes.INSURED_INFO,
  EndorsementRoutes.COVERAGE,
  EndorsementRoutes.SUMMARY,
  EndorsementRoutes.UW_REVIEW,
  EndorsementRoutes.CHECKOUT,
];

export const getStepOrder = (showUwReview: boolean) =>
  showUwReview
    ? STEP_ORDER
    : STEP_ORDER.filter((step) => step !== EndorsementRoutes.UW_REVIEW);

export const STEP_LABEL: Record<EndorsementRoutes, string> = {
  [EndorsementRoutes.INSURED_INFO]: "Insured Info",
  [EndorsementRoutes.COVERAGE]: "Coverage",
  [EndorsementRoutes.SUMMARY]: "Summary",
  [EndorsementRoutes.UW_REVIEW]: "UW Review",
  [EndorsementRoutes.CHECKOUT]: "Checkout",
};

export const VIEW_ONLY_STEPS: EndorsementRoutes[] = [
  EndorsementRoutes.INSURED_INFO,
  EndorsementRoutes.COVERAGE,
];

export const getLockedSteps = (
  isViewOnly: boolean,
  isUnderwritingFailed: boolean
) => [
  ...(isViewOnly ? VIEW_ONLY_STEPS : []),
  ...(isUnderwritingFailed ? [EndorsementRoutes.CHECKOUT] : []),
];

export const PRICE_HIDDEN_STEPS: EndorsementRoutes[] = [
  EndorsementRoutes.SUMMARY,
  EndorsementRoutes.UW_REVIEW,
  EndorsementRoutes.CHECKOUT,
];

export const MODE_EYEBROW: Record<EndorsementMode, string> = {
  create: "New Endorsement",
  update: "Edit Endorsement",
  issue: "Issue Endorsement",
  review: "Review Endorsement",
};

export const LOADED_ON_OPEN_MODES: readonly EndorsementMode[] = [
  "update",
  "issue",
  "review",
];

export const NEXT_BUTTON_LABEL: Record<EndorsementRoutes, string> = {
  [EndorsementRoutes.INSURED_INFO]: "Continue to insured info",
  [EndorsementRoutes.COVERAGE]: "Continue to coverage",
  [EndorsementRoutes.SUMMARY]: "Continue to summary",
  [EndorsementRoutes.UW_REVIEW]: "Continue to UW review",
  [EndorsementRoutes.CHECKOUT]: "Continue to checkout",
};
// UW Review
export const ISSUE_BUTTON_LABEL = "Issue endorsement change";
